import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

export default function CatalogueLayout() {
  return (
    <Box h='100%'>
      <Box py={{ lg: 0 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
